export default function Support() {
  return (
    <div className="prose">
      <h1>Support</h1>
      <p>
        We’re here to help. Reach out with any issue related to Echo Steps and
        we’ll get back to you as soon as possible.
      </p>
      <h2>Contact</h2>
      <p>
        Email:{" "}
        <a href="mailto:support@echo-steps.com">support@echo-steps.com</a>
        <br />
        Address: Echo Steps, 21 Herzl St, Tel Aviv-Yafo, 66000, Israel
      </p>
      <h2>FAQ</h2>
      <p>
        <strong>Refunds</strong>: Purchases made through the App Store are
        managed by Apple’s refund policies.
      </p>
      <p>
        <strong>Privacy</strong>: See our{" "}
        <a href="/privacy-policy">Privacy Policy</a> for how we handle data.
      </p>
    </div>
  );
}
